import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';
import { LoadingService } from '../../Services/Loading/loading-service.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-loading-animation',
    templateUrl: './loading-animation.component.html',
    styleUrls: ['./loading-animation.component.scss'],
    standalone: false
})
export class LoadingAnimationComponent implements OnInit, OnDestroy {
  isLoading: boolean = false;
  private loadingSubscription: Subscription | undefined;

  constructor(
    private loadingService: LoadingService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(
      (isLoading) => {
        this.isLoading = isLoading;
        this.cdr.detectChanges(); // Add this line
      }
    );
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }
}
